import { Method } from 'axios';
import { Executable } from '../executable';

/**
 * The the program for the provided programId.
 */
export class DeleteProgram extends Executable<boolean> {
  public brandId?: number;

  public programId?: number;

  public getMethod(): Method {
    return 'delete';
  }

  public getResponse(apiResponse: any): boolean {
    return apiResponse;
  }

  public getURLPath(tenantId?: string): string {
    if (!this.brandId) throw new Error('brandId is required');
    if (!this.programId) throw new Error('programId is required');
    return `/${this.brandId}/programs/${this.programId}}`;
  }

  constructor(brandId: number, programId: number) {
    super();
    this.brandId = brandId;
    this.programId = programId;
  }

  /**
   * getBody is used by the BambuClient to properly construct the request object body.
   * @returns Returns the expected body of the request utilizing the defined request attributes.
   */
  getBody(): undefined {
    return undefined;
  }

  /**
   * getRootPath is used by the BambuClient to properly construct the request call.
   * @returns The root path of the request
   */
  getRootPath(): string | undefined {
    return 'brands';
  }
}
